const packageActions = {
  FETCH_PACKAGES_START: 'FETCH_PACKAGES_START',
  FETCH_PACKAGES_DONE: 'FETCH_PACKAGES_DONE',
  FETCH_PACKAGES_ERROR: 'FETCH_PACKAGES_ERROR',
  FETCH_PACKAGES_CANCELLED: 'FETCH_PACKAGES_CANCELLED',
  FETCH_PACKAGES_DENIED: 'FETCH_PACKAGES_DENIED',

  FETCH_SOCIAL_POSTING_PACKAGES_START: 'FETCH_SOCIAL_POSTING_PACKAGES_START',
  FETCH_SOCIAL_POSTING_PACKAGES_DONE: 'FETCH_SOCIAL_POSTING_PACKAGES_DONE',
  FETCH_SOCIAL_POSTING_PACKAGES_ERROR: 'FETCH_SOCIAL_POSTING_PACKAGES_ERROR',
  FETCH_SOCIAL_POSTING_PACKAGES_CANCELLED: 'FETCH_SOCIAL_POSTING_PACKAGES_CANCELLED',
  FETCH_SOCIAL_POSTING_PACKAGES_DENIED: 'FETCH_SOCIAL_POSTING_PACKAGES_DENIED',

  FETCH_HIGHLIGHTED_PACKAGES_START: 'FETCH_HIGHLIGHTED_PACKAGES_START',
  FETCH_HIGHLIGHTED_PACKAGES_DONE: 'FETCH_HIGHLIGHTED_PACKAGES_DONE',
  FETCH_HIGHLIGHTED_PACKAGES_ERROR: 'FETCH_HIGHLIGHTED_PACKAGES_ERROR',
  FETCH_HIGHLIGHTED_PACKAGES_CANCELLED: 'FETCH_HIGHLIGHTED_PACKAGES_CANCELLED',
  FETCH_HIGHLIGHTED_PACKAGES_DENIED: 'FETCH_HIGHLIGHTED_PACKAGES_DENIED',

  FETCH_TOP_RESULT_PACKAGES_START: 'FETCH_TOP_RESULT_PACKAGES_START',
  FETCH_TOP_RESULT_PACKAGES_DONE: 'FETCH_TOP_RESULT_PACKAGES_DONE',
  FETCH_TOP_RESULT_PACKAGES_ERROR: 'FETCH_TOP_RESULT_PACKAGES_ERROR',
  FETCH_TOP_RESULT_PACKAGES_CANCELLED: 'FETCH_TOP_RESULT_PACKAGES_CANCELLED',
  FETCH_TOP_RESULT_PACKAGES_DENIED: 'FETCH_TOP_RESULT_PACKAGES_DENIED',

  fetchPackages: (payload = {}) => ({
    type: packageActions.FETCH_PACKAGES_START,
    payload,
  }),

  fetchSocialPostingPackages: () => ({
    type: packageActions.FETCH_SOCIAL_POSTING_PACKAGES_START,
  }),

  fetchHighlightedPackages: () => ({
    type: packageActions.FETCH_HIGHLIGHTED_PACKAGES_START,
  }),

  fetchTopResultPackages: () => ({
    type: packageActions.FETCH_TOP_RESULT_PACKAGES_START,
  }),
};

export default packageActions;
